const AI_TOOL_LABELS = {
  apply_filters: 'Applying filters',
  annotate_listings: 'Scoring matches',
  db_search: 'Searching listings',
  get_price_history: 'Checking price history',
  get_shipping_estimate: 'Checking shipping',
  get_support_docs: 'Checking support docs',
  lookup_product: 'Checking product details',
  price_check: 'Checking prices',
  respond: 'Preparing answer',
  seller_lookup: 'Checking seller details',
  submit_pending_product: 'Saving product details',
  submit_support_ticket: 'Preparing support ticket',
  web_fetch: 'Reading source',
  web_search: 'Searching the web',
};

const toTitleCase = value =>
  String(value || '')
    .replace(/_/g, ' ')
    .replace(/\b\w/g, char => char.toUpperCase());

export const getAiToolLabel = toolName => {
  const normalizedName = String(toolName || '').trim();
  return AI_TOOL_LABELS[normalizedName] || toTitleCase(normalizedName) || 'Working';
};

const normalizeSteps = steps => (Array.isArray(steps) ? steps : []);

export const startAiTool = (steps, toolName) => {
  const normalizedName = String(toolName || '').trim();
  if (!normalizedName) return normalizeSteps(steps);

  const nextSteps = normalizeSteps(steps).map(step =>
    step.status === 'active' ? { ...step, status: 'complete' } : step
  );
  const existingIndex = nextSteps.findIndex(step => step.tool === normalizedName);

  if (existingIndex >= 0) {
    nextSteps[existingIndex] = {
      ...nextSteps[existingIndex],
      label: getAiToolLabel(normalizedName),
      status: 'active',
    };
    return nextSteps;
  }

  return [
    ...nextSteps,
    {
      tool: normalizedName,
      label: getAiToolLabel(normalizedName),
      status: 'active',
    },
  ];
};

export const completeAiTool = (steps, toolName) => {
  const normalizedName = String(toolName || '').trim();
  if (!normalizedName) return normalizeSteps(steps);

  const nextSteps = normalizeSteps(steps);
  const existingIndex = nextSteps.findIndex(step => step.tool === normalizedName);

  if (existingIndex === -1) {
    return [
      ...nextSteps,
      {
        tool: normalizedName,
        label: getAiToolLabel(normalizedName),
        status: 'complete',
      },
    ];
  }

  return nextSteps.map((step, index) =>
    index === existingIndex
      ? {
          ...step,
          label: getAiToolLabel(normalizedName),
          status: 'complete',
        }
      : step
  );
};

export const finalizeAiTools = steps =>
  normalizeSteps(steps).map(step =>
    step.status === 'active' ? { ...step, status: 'complete' } : step
  );

export const hasVisibleAiTools = steps => normalizeSteps(steps).length > 0;
